import React from "react";
import ScrollableSlider from "../../Molecules/ScrollableSlider/ScrollableSlider";
import classNames from "classnames";
import useStore from "../../../store/useStore";
import './TopMenuSlider.scss';
import Button from "../../Atoms/Button/Button";

interface Categories {
    name: string;
    categoryId: number;
    categoryUrl: string;
}
interface TopMenuSliderProps {
    categories: Categories[],
    currentCategoryId?: number,
    categoryName?: string,
    navAriaLabel?: string,
}
const TopMenuSlider: React.FC<TopMenuSliderProps> = ({ categories, currentCategoryId, categoryName, navAriaLabel }) => {    
    const {
        setAnalyticsProducts,
        setAttemptTracker,
        headerHeightCal: headerHeight,
    } = useStore();
    const onClickTab = (e: React.SyntheticEvent, item: any) => {
        window.location.href = item.categoryUrl;
        e.stopPropagation();
        setAnalyticsProducts({
            clickActionName: item.name,
            componentTitle: 'category tab',
            productCategory: categoryName,
        });
        setAttemptTracker([{ name: 'category_tab', isClickable: true }]);
    };
    return (<>
        <nav
            className="menu-slider__comp"
            aria-label={navAriaLabel}
            style={{ top: headerHeight }}
        >
            <ScrollableSlider>
                {categories?.map((item: Categories, index: number) => (
                    <li key={`${index}-${item.categoryId}`}>
                        <Button
                            className={classNames('inner-slide', {
                                selected: currentCategoryId === item.categoryId,
                            })}
                            data-testid={`slider-${item.categoryId}`}
                            data-testauto-id={`${item.name}`.replace(/\s+/g, '-').toLowerCase()}
                            testAutoId={`${item.name}`.replace(/\s+/g, '-').toLowerCase()}
                            onClick={e => onClickTab(e as React.SyntheticEvent, item)}
                            aria-selected={currentCategoryId === item.categoryId}
                            aria-label={`${item.name} ${(window as any).buttonText} ${currentCategoryId === item.categoryId ? 'selected' : ''
                                }`}
                            role='option'
                        >
                            {item.name}
                        </Button>
                    </li>
                ))}
            </ScrollableSlider>
        </nav>
    </>

    )
}
export default TopMenuSlider;